module.exports = __webpack_public_path__ + "img/introcover.101519ec.jpg";